module.exports = __webpack_public_path__ + "static/img/partner-cti.ca0cf4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-cti.png
// module id = 5FWT
// module chunks = 34